import React from "react";
import Loadable from "react-loadable";
import CircularProgress from "../../../components/CircularProgress";

// ToDo:: change loading ...
const AsyncIndex = Loadable({
  loader: () => import("./NewsDetailsComponent"),
  loading: () => <CircularProgress className="" />,
});

export default AsyncIndex;
